import { useEffect, useCallback } from 'react';

/**
 * Hook für globale Keyboard Shortcuts
 * @param {Object} shortcuts - Object mit key -> callback Paaren
 * @param {boolean} enabled - Ob Shortcuts aktiv sind (default: true)
 */
export function useKeyboardShortcuts(shortcuts, enabled = true) {
  const handleKeyDown = useCallback((event) => {
    // Nicht auslösen wenn in Input, Textarea oder contentEditable
    const target = event.target;
    const tagName = target.tagName.toLowerCase();
    const isEditable = target.isContentEditable;
    const isInput = tagName === 'input' || tagName === 'textarea' || tagName === 'select';

    if (isInput || isEditable) {
      // Escape sollte trotzdem funktionieren
      if (event.key !== 'Escape') {
        return;
      }
    }

    // Shortcut-Key ermitteln
    let key = event.key.toLowerCase();

    // Modifier-Tasten berücksichtigen
    if (event.metaKey || event.ctrlKey) {
      key = `cmd+${key}`;
    }
    if (event.shiftKey && !['?'].includes(event.key)) {
      key = `shift+${key}`;
    }

    // ? wird mit Shift getippt, daher speziell behandeln
    if (event.key === '?') {
      key = '?';
    }

    const callback = shortcuts[key];
    if (callback) {
      event.preventDefault();
      callback(event);
    }
  }, [shortcuts]);

  useEffect(() => {
    if (!enabled) return;

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown, enabled]);
}

// Standard-Shortcuts für verschiedene Kontexte
export const SHORTCUT_KEYS = {
  HELP: '?',
  SEARCH: 'cmd+k',
  NEW_CUSTOMER: 'k',
  NEW_REQUEST: 'n',
  NEW_APPOINTMENT: 't',
  EDIT: 'e',
  ESCAPE: 'escape',
  SAVE: 'cmd+s',
};
